// src/config.js

export const API_BASE_URL = process.env.REACT_APP_API_URL || (
  process.env.NODE_ENV === 'development'
    ? 'http://127.0.0.1:8000'   // Local Django server
    : 'https://api.trekverse.org' // <-- FIXED: Points to your new AWS backend!
);